import React, {type ReactNode} from 'react';

type ReproduceRunInfoRowProps = {
  content: string | null;
  controls?: ReactNode;
  label: string;
};

export function ReproduceRunInfoRow({
  content,
  controls,
  label,
}: ReproduceRunInfoRowProps) {
  return (
    <>
      <div className="font-semibold text-moon-600 dark:text-wb-text-secondary pr-16">
        {label}
      </div>
      <div className="overflow-hidden text-ellipsis whitespace-nowrap">
        {content}
      </div>
      <div className="justify-self-end flex flex-row gap-8 items-center">
        {controls}
      </div>
    </>
  );
}

export function ReproduceRunInfoRows({children}: {children: ReactNode}) {
  return (
    <div className="grid grid-cols-[min-content_1fr_min-content] gap-x-16 gap-y-8 items-center">
      {children}
    </div>
  );
}
